module.exports = __webpack_public_path__ + "banquet/components/images/tag_delete.c58c4544d087e153bbef739e7ae12059.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/tag_delete.svg
// module id = 1711
// module chunks = 1